/**
 * @file 投稿ボタン
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname BtnTestMail
 * @classdesc 投稿ボタン
 */
export default class BtnTestMail {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {object} controller - controller オブジェクト
	 */
	constructor($e, controller) {
		console.log('BtnTestMail.constructor');
		this._$e = $e;
		this._controller = controller;
		this._$modal = $('#modal-test-modal');
		this._$testMailModal = new bootstrap.Modal(document.getElementById('modal-test-mail'))
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof BtnTestMail
	 * @return {undefined}
	 */
	onClick() {
		console.log('BtnTestMail.onClick');
		this._controller.validate();
		setTimeout(() => {
			this.showModal();
		}, 500);
		//$('#modal-submit')[0].show();
	};

	showModal() {
		console.log('BtnTestMail.showModal');
		$('[name=test-email]').removeClass('is-invalid');
		$('#form-test-mail').find('.error-tip').removeClass('on').find('.error-tip-inner').html('');
		if ($('.validate').hasClass('is-invalid')) {
			Common.showErrorModal();
			return;
		}else{
			this._$testMailModal.show();
		}
	}
}
